import React, { useState } from "react";
import { Image } from "react-bootstrap";
import playButton from "../../../assets/images/play_button.svg";
import VideoPlayer from "../../../components/textField/VideoPlayer";
import { formatDate } from "../../../constant/DateFormat";
import ReactPlayer from "react-player";
import { AspectRatio } from "react-aspect-ratio";
import { Button, Col, Modal, Row } from "react-bootstrap";
import icTitle from "../../../assets/images/ic-play.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import { truncateText } from "../../../constant/TruncateText";
import { dev } from "../../../features/network/ApiCall";

const VideoItem = ({ item, columns = 4 }: { item: any; columns: number }) => {
  const [modalShow, setModalShow] = useState(false);

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  return (
    <>
      <Col
        lg={columns}
        md={columns}
        sm={columns}
        style={{ marginBottom: "16px" }}
      >
        <div className="b_shadow" style={styles.card}>
          <p>
            {/* <Image src={playButton} /> */}
            <div className="card-media">
              <a href="#img1">
                <AspectRatio ratio="3/4" style={{ maxWidth: "100%" }}>
                  <Image
                    src={`${dev}/admin/download?fileName=${item.thumbnail}`}
                    className="McCardImage"
                    onClick={handleShow}
                  />
                </AspectRatio>
              </a>
            </div>

            {/* lightbox container hidden with CSS  */}
            <a href="#_" className="lightbox" id="img1">
              {/* <iframe width="560" height="315" src={item.externalUrl} title="YouTube video player"></iframe>                  */}
              {/* <iframe width="870" height="489" src="https://www.youtube.com/watch?v=Ow_vlWsLVmk"></iframe>  */}
              {/* <VideoPlayer handleClose={handleClose} handleShow={handleShow} videoUrl={item.externalUrl}/> */}
            </a>
          </p>
          <div className="videodesc">
            <h4 style={styles.title}>{truncateText(item?.title, 45)}</h4>
            <p style={styles.contents}>{formatDate(item.updatedDate)}</p>
          </div>
        </div>
      </Col>
      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title="Videos" />
        <ENGModalBody
          contents={
            <>
              <ReactPlayer
                url={`${item.externalUrl}`}
                //url="sample.mp4"
                width="100%"
                height="350px"
                // playing={true}
                controls={true}
              />
            </>
          }
        />
        <ENGModalFooter closeMethod={handleClose} />
      </Modal>
    </>
  );
};

const styles: any = {
  img1: {
    width: "80%",
  },
  card: { height: "280px" },
  title: {
    fontFamily: "QuantumRiseGX",
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.44,
    letterSpacing: "normal",
  },

  contents: {
    color: "#6d6e71",
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.57,
    letterSpacing: "normal",
  },
};

export default VideoItem;
